import { useQuery } from '@tanstack/react-query'
import { api } from './api'

// Someone in your Framily: everyone in the trees of all your circles, one row a person however many circles they're in.
export type FramilyPerson = {
  id: string
  name: string
  living: boolean
  born: string | null
  died: string | null
  pet: boolean
  portrait: string | null
  me: boolean
  account: boolean
  circles: string[]
  // Their record in each of those circles.
  ids: string[]
}

// A new circle can start with this many of them (the same limit as the server's).
export const MAX_BRING = 100

export const useFramily = () =>
  useQuery({
    queryKey: ['framily'],
    queryFn: async () => (await api<{ people: FramilyPerson[] }>('/framily')).people,
  })

// The people a search finds, by name or by a circle they're in.
export function findIn(people: FramilyPerson[], search: string) {
  const words = search.trim().toLowerCase().split(/\s+/).filter(Boolean)
  return people.filter((p) => {
    const text = [p.name, ...p.circles].join(' ').toLowerCase()
    return words.every((w) => text.includes(w))
  })
}
